import { render, staticRenderFns } from "./PermissionTreeView.vue?vue&type=template&id=9ad69f8a"
import script from "./PermissionTreeView.vue?vue&type=script&lang=js"
export * from "./PermissionTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports